import { makeAutoObservable, observable, toJS } from 'mobx'
import { createViewModel } from 'mobx-utils'
import { Participant } from '../../../datastores/participant'
import { deserialize } from 'serializr'
import cuid from 'cuid'
export class ParticipantsViewModel {
  /** @type {import('mobx').IObservableArray<import('mobx-utils').IViewModel<Participant>>} */
  ps = observable([])
  /** @type {import('mobx').IObservableArray<Participant>} */
  participants = observable([])

  constructor(participants) {
    makeAutoObservable(this)
    this.participants = (participants ?? observable([]))
    this.ps.replace(this.participants.map(p => createViewModel(p)))
  }
  get isDirty() {
    return this.ps.some(p => p.isDirty)
  }
  submit() {
    this.ps.forEach(p => {
      p.submit()
    })
    this.participants.replace(this.ps.map(p => p.model));
  }
  /**
   * @param {import('../../../datastores/eventGroup').EventGroup[]} eventGroups
   */
  submitToAll(eventGroups) {
    this.ps.forEach(p => {
      p.submit()
      eventGroups.forEach(eg => {
        let jsonObject = toJS(p.model)
        jsonObject.id = cuid()
        eg.addParticipant(deserialize(Participant, jsonObject))
      })
    })
    this.participants.replace([])
  }
  reset() {
    this.ps.forEach(p => {
      p.reset()
    })
    this.ps.replace(this.participants.map(p => createViewModel(p)))
    if (this.ps.length === 0) {
      this.ps.push(createViewModel(new Participant(cuid())))
    }
  }
  delete(p) {
    this.ps.splice(this.ps.indexOf(p), 1)
    if (this.ps.length === 0) {
      this.ps.push(createViewModel(new Participant(cuid())))
    }
  }
}
